module.exports = __webpack_public_path__ + "img/dj.8e96ea74.jpg";